import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProjectCard.css';

const ProjectCard = ({ id, title, level, rating, category, description }) => {
    const navigate = useNavigate();
    const isComingSoon = id === 'coming-soon';

    const handleBrowse = () => {
        if (isComingSoon) return;
        // Navigate to project details page
        // Using encodeURIComponent to make the URL safe
        navigate(`/project/${encodeURIComponent(title)}`);
    };

    const handleCardKeyDown = (e) => {
        if (isComingSoon) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleBrowse();
        }
    };

    return (
        <div
            className={`project-card ${isComingSoon ? 'coming-soon-card' : ''}`}
            onClick={handleBrowse}
            onKeyDown={handleCardKeyDown}
            role={isComingSoon ? undefined : 'button'}
            tabIndex={isComingSoon ? undefined : 0}
            aria-disabled={isComingSoon ? true : undefined}
        >
            <div className="card-header">
                <span className={`badge ${isComingSoon ? 'badge-warn' : ''}`}>{category}</span>
                <span className="level">Lvl {level}</span>
            </div>
            <div className="card-body">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </div>
    );
};


export default ProjectCard;

